import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';

import { setDay, setMonth, setYear } from '../../redux/slices/ui';

import { useNotificaciones } from './hooks/useNotificaciones';
import { useRemove } from './hooks/useRemove';
import { useClear } from './hooks/useClear';

import styles from './Notices.module.css';

import { colors } from '../../types/types';

export const Notices = () => {

    // Beeps de notificaciones
        const seenIdsRef = useRef(new Set());
        const initializedRef = useRef(false);

        const audioCtxRef = useRef(null);
        const audioReadyRef = useRef(false);
        const pendingBeepRef = useRef(false);
        const beepEnabledRef = useRef(false);

        function getAudioContextCtor() {
            return typeof window !== 'undefined'
                ? (window.AudioContext || window.webkitAudioContext || null)
                : null;
        }

        function ensureAudioCtxCreated() {
            const Ctor = getAudioContextCtor();
            if (!Ctor) return null;
            if (!audioCtxRef.current) audioCtxRef.current = new Ctor();
            return audioCtxRef.current;
        }

        function unlockAudio() {
            const ctx = ensureAudioCtxCreated();
            if (!ctx) return;
            if (ctx.state === 'suspended') ctx.resume().catch(() => {});
            audioReadyRef.current = true;
            beepEnabledRef.current = true;

            if (pendingBeepRef.current) pendingBeepRef.current = false;
        }

        function beepNow(frequency = 880, durationMs = 120) {
            try {
                const ctx = audioCtxRef.current;
                if (!ctx) return;
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();
                osc.type = 'sine';
                osc.frequency.value = frequency;
                gain.gain.value = 0.3;
                osc.connect(gain).connect(ctx.destination);
                osc.start();
                gain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + durationMs / 1000);
                osc.stop(ctx.currentTime + durationMs / 1000);
            } catch {}
        }

        function requestBeep() {
            if (!beepEnabledRef.current || !audioReadyRef.current || !audioCtxRef.current) {
                pendingBeepRef.current = true;
                return;
            }
            if (document.visibilityState !== 'visible') return; // opcional
            beepNow();
        }

        function flattenNotices(grouped) {
            return Object.values(grouped || {}).reduce((acc, arr) => {
                if (Array.isArray(arr)) acc.push(...arr);
                return acc;
            }, []);
        }
    // Beeps de notificaciones

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const dropdownRef = useRef(null);
    const bellBtnRef = useRef(null);

    const { user } = useSelector(state => state.auth);

    const { notificacionesQuery: { isLoading, isError, data: { data: notificaciones, counter } } } = useNotificaciones();

    const { removeMutation: { mutate: remove } } = useRemove();

    const { clearMutation: { mutate: clear } } = useClear();

    const renderIcon = (category, type) => {
        if(category === 'MEDICO'){
            return <Icon.Person size={20} />;
        }
        // if(category === 'CITA'){
        //     return <Icon.Calendar3 size={20} />;
        // }
        // if(category === 'INMUNOTERAPIA'){
        //     return <Icon.Virus size={20} />;
        // }
        // if(category === 'LOGIN'){
        //     if(type === 'LOGIN'){
        //         return <Icon.BoxArrowInRight size={20} />;
        //     }else{
        //         return <Icon.BoxArrowRight size={20} />;
        //     }
        // }
        // if(category === 'APP'){
        //     return <Icon.Phone size={20} />;
        // }
        return <></>;
    }

    const handleNavigate = (e, type, category, data) => {
        e.preventDefault();
        e.stopPropagation();
        switch (category) {
            case 'PACIENTE':
                switch (type) {
                    case 'CREATE':
                        remove({ id: data._id });
                        dropdownRef.current?.hide();
                        navigate(`/paciente/view/${data.paciente._id}`);
                        break;
                
                    default:
                        break;
                }
                break;
            case 'INMUNOTERAPIA':
                switch (type) {
                    case 'CREATE':
                    case 'UPDATE':
                    case 'DELETE':
                        remove({ id: data._id });
                        dropdownRef.current?.hide();
                        navigate(`/paciente/consulta/${data.paciente._id}`);
                        break;
                
                    default:
                        break;
                }
                break;
            case 'CITA':
                switch (type) {
                    case 'PRECREATE':
                        dropdownRef.current?.hide();
                        navigate(`/pendiente/${ data._id }/${ data.citaPendiente.id }`);
                        break;
                    case 'CREATE':
                    case 'UPDATE':
                    case 'DELETE':
                        remove({ id: data._id });
                        dispatch(setDay(data.cita.data.day));
                        dispatch(setMonth(data.cita.data.month));
                        dispatch(setYear(data.cita.data.year));
                        dropdownRef.current?.hide();
                        navigate(`/`);
                        break;
                
                    default:
                        break;
                }
                break;
            case 'LOGIN':
                switch (type) {
                    case 'LOGIN':
                        remove({ id: data._id });
                        dropdownRef.current?.hide();
                        break;
                
                    default:
                        break;
                }
                break;
            case 'APP':
                switch (type) {
                    case 'UPDATE':
                        remove({ id: data._id });
                        dropdownRef.current?.hide();
                        navigate(`/paciente/view/${data.paciente._id}`);
                        break;
                
                    default:
                        break;
                }
                break;
        
            default:
                break;
        }
    }

    const handleRemove = (e, id) => {
        e.preventDefault();
        e.stopPropagation();
        remove({ id });
    }

    const handleClear = (e) => {
        e.preventDefault();
        e.stopPropagation();
        clear();
    }

    useEffect(() => {
        if (!bellBtnRef.current) return;

        const DropdownCtor = window.bootstrap?.Dropdown;
        if (!DropdownCtor) {
            console.warn('Bootstrap JS no está cargado (window.bootstrap no existe).');
            return;
        }

        dropdownRef.current = DropdownCtor.getOrCreateInstance(bellBtnRef.current);

        return () => {
            dropdownRef.current?.dispose?.();
            dropdownRef.current = null;
        };
    }, []);

    // Beeps de notificaciones
        useEffect(() => {
            const handler = () => unlockAudio();
            window.addEventListener('pointerdown', handler, { once: true });
            window.addEventListener('keydown', handler, { once: true });
            window.addEventListener('touchstart', handler, { once: true, passive: true });
            return () => {
                window.removeEventListener('pointerdown', handler);
                window.removeEventListener('keydown', handler);
                window.removeEventListener('touchstart', handler);
            };
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);

        useEffect(() => {
        const seen = seenIdsRef.current;
            const all = flattenNotices(notificaciones);
            const newlyArrived = all.filter(n => !seen.has(n._id));

            if (initializedRef.current && newlyArrived.length > 0) {
                requestBeep();
            }

            newlyArrived.forEach(n => seen.add(n._id));
            if (seen.size > 500) {
                const last500 = Array.from(seen).slice(-500);
                seen.clear();
                last500.forEach(id => seen.add(id));
            }
            initializedRef.current = true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [notificaciones])
    // Beeps de notificaciones

    return (
        <div>
            <div className={"dropdown " + styles.navbarDropdown}>
                <button ref={bellBtnRef} className={"btn " + styles.navbarDropdownButton} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <Icon.Bell className={styles.a} />
                    {(counter > 0 && !isLoading && !isError) && <div className={styles.notiCounter}>{ (isLoading || isError) ? '#' : counter }</div>}
                </button>
                <ul className={"dropdown-menu " + styles.navbarDropdownMenu}>
                    <li>
                        <div className={styles.navbarDropdownTop}>
                            <div>
                                <div className={styles.navbarDropdownHeader}>Notificaciones</div>
                                <div className={styles.navbarDropdownSubHeader}>{user.displayName}</div>
                            </div>
                            <div>
                                <div className={styles.iconCol}>
                                    <span className={styles.icoBox} style={{ fontSize: 30, color: colors.DANGER }}>
                                        <Icon.X className={styles.navbarDropdownClose + " " + styles.svgFix} color={colors.DANGER} />
                                    </span>
                                </div>
                            </div>
                        </div>
                        <hr className={styles.divider} />
                    </li>
                    {(Object.keys(notificaciones).length !== 0) &&                    
                    <li className='text-end'><span className={styles.borrar} onClick={(e) => handleClear(e)}>Borrar</span></li>
                    }
                    <div className={styles.noticesContainer}>
                        {Object.entries(notificaciones).map(([day, items]) => (
                            <React.Fragment key={day}>
                                <li className={"dropdown-header px-3 " + styles.dateText}>{items[0].fechaFormato}</li>
                                {items.map(n => (
                                    <li key={n._id} className={styles.navbarDropdownMenuItem}>
                                        <div className={"dropdown-item gap-2 " + styles.navbarDropdownMenuItemContent} onClick={(e) => handleNavigate(e, n.type, n.category, n)} >
                                            { renderIcon(n.category, n.type) }
                                            <div className="me-auto">
                                                <div>{n.content}</div>
                                            </div>
                                            <button className="btn btn-sm btn-link p-0" onClick={(e) => handleRemove(e, n._id)} aria-label="Eliminar notificación" title="Eliminar"><Icon.X size={20} /></button>
                                        </div>
                                    </li>
                                ))}
                            </React.Fragment>
                        ))}
                    </div>
                    {/* Vacío */}
                    {Object.keys(notificaciones).length === 0 && (
                        <li className="px-3 py-2 text-muted">Sin notificaciones</li>
                    )}
                </ul>
            </div>
        </div>
    )
}